import React, { useState, useEffect, useRef } from "react";
import ReactDOM from "react-dom";
import PropTypes from "prop-types";
import { Link } from "react-router-dom";
import { LuUser2 } from "react-icons/lu";
import { IoTicketOutline } from "react-icons/io5";
import { TbFileInvoice } from "react-icons/tb";
import { TiContacts, TiBusinessCard } from "react-icons/ti";
import { BsBank2 } from "react-icons/bs";
import { withTranslation } from "react-i18next";
import { connect } from "react-redux";
import withRouter from "../withRouter";
import userImg from "../../../assets/images/users/User.png";

const ProfileMenu = (props) => {
  const [menu, setMenu] = useState(false);
  const [dropdownPosition, setDropdownPosition] = useState({ top: 0, right: 0 });
  
  const buttonRef = useRef(null);
  const dropdownRef = useRef(null);

  // Get user data
  const obj = JSON.parse(localStorage.getItem("authEventKagoUser"));
  const name = obj?.data?.data?.firstName;
  const userImage = obj?.data?.data?.photo;
  const role = obj?.data?.data?.roles;
  const capitalizedFirstName = name
    ? name.charAt(0).toUpperCase() + name.slice(1).toLowerCase()
    : "";

  // Calculate dropdown position when opened
  useEffect(() => {
    if (menu && buttonRef.current) {
      const rect = buttonRef.current.getBoundingClientRect();
      setDropdownPosition({
        top: rect.bottom + window.scrollY + 8,
        right: window.innerWidth - rect.right + window.scrollX
      });
    }
  }, [menu]);

  // Close menu when clicking outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setMenu(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  const toggle = () => setMenu(!menu);

  // Profile dropdown content
  const dropdownContent = (
    <div
      ref={dropdownRef}
      className="profile-dropdown-menu"
      style={{
        position: 'fixed',
        top: `${dropdownPosition.top}px`,
        right: `${dropdownPosition.right}px`,
        minWidth: '240px',
        backgroundColor: '#25282b',
        border: '1px solid #334155',
        borderRadius: '12px',
        boxShadow: '0 8px 24px rgba(0,0,0,0.5)',
        zIndex: 9999999,
        padding: '8px 0',
        animation: 'dropdownSlide 0.2s ease-out',
        overflow: 'visible'
      }}
    >
      {/* User Info Header */}
      <div style={{ 
        padding: '12px 16px', 
        borderBottom: '1px solid #334155',
        display: 'flex',
        alignItems: 'center',
        gap: '12px'
      }}>
        <img
          className="rounded-circle"
          src={userImage ? userImage : userImg}
          alt="Profile"
          style={{ width: '40px', height: '40px', objectFit: 'cover' }}
        />
        <div>
          <h6 className="m-0" style={{ color: '#f1f5f9', fontSize: '14px', fontWeight: '600' }}>
            {capitalizedFirstName || "User"}
          </h6>
          <p className="m-0" style={{ color: '#94a3b8', fontSize: '12px' }}>
            {role?.[0] || "Member"}
          </p>
        </div>
      </div>

      {/* Menu Items */}
      <Link 
        to="/userprofile" 
        style={{
          display: 'flex',
          alignItems: 'center',
          gap: '12px',
          padding: '10px 16px',
          color: '#e2e8f0',
          textDecoration: 'none',
          fontSize: '13px',
          transition: 'all 0.2s ease'
        }}
        onMouseEnter={(e) => {
          e.currentTarget.style.backgroundColor = '#334155';
          e.currentTarget.style.color = '#f68a20';
        }}
        onMouseLeave={(e) => {
          e.currentTarget.style.backgroundColor = 'transparent';
          e.currentTarget.style.color = '#e2e8f0';
        }}
        onClick={() => setMenu(false)}
      >
        <LuUser2 size={16} style={{ color: '#f68a20', flexShrink: 0 }} />
        <span>{props.t("Profile")}</span>
      </Link>

      {role?.includes("event_organizer") && (
        <Link 
          to="/merchant-details" 
          style={{
            display: 'flex',
            alignItems: 'center',
            gap: '12px',
            padding: '10px 16px',
            color: '#e2e8f0',
            textDecoration: 'none',
            fontSize: '13px',
            transition: 'all 0.2s ease'
          }}
          onMouseEnter={(e) => {
            e.currentTarget.style.backgroundColor = '#334155';
            e.currentTarget.style.color = '#f68a20';
          }}
          onMouseLeave={(e) => {
            e.currentTarget.style.backgroundColor = 'transparent';
            e.currentTarget.style.color = '#e2e8f0';
          }}
          onClick={() => setMenu(false)}
        >
          <BsBank2 size={16} style={{ color: '#f68a20', flexShrink: 0 }} />
          <span>{props.t("Ticket Payment")}</span>
        </Link>
      )}

      <Link 
        to="/my-business-card" 
        style={{
          display: 'flex',
          alignItems: 'center',
          gap: '12px',
          padding: '10px 16px',
          color: '#e2e8f0',
          textDecoration: 'none',
          fontSize: '13px',
          transition: 'all 0.2s ease'
        }}
        onMouseEnter={(e) => {
          e.currentTarget.style.backgroundColor = '#334155';
          e.currentTarget.style.color = '#f68a20';
        }}
        onMouseLeave={(e) => {
          e.currentTarget.style.backgroundColor = 'transparent';
          e.currentTarget.style.color = '#e2e8f0';
        }}
        onClick={() => setMenu(false)}
      >
        <TiBusinessCard size={16} style={{ color: '#f68a20', flexShrink: 0 }} />
        <span>{props.t("Business Card")}</span>
      </Link>

      <Link 
        to="/my-contacts" 
        style={{
          display: 'flex',
          alignItems: 'center',
          gap: '12px',
          padding: '10px 16px',
          color: '#e2e8f0',
          textDecoration: 'none',
          fontSize: '13px',
          transition: 'all 0.2s ease'
        }}
        onMouseEnter={(e) => {
          e.currentTarget.style.backgroundColor = '#334155';
          e.currentTarget.style.color = '#f68a20';
        }}
        onMouseLeave={(e) => {
          e.currentTarget.style.backgroundColor = 'transparent';
          e.currentTarget.style.color = '#e2e8f0';
        }}
        onClick={() => setMenu(false)}
      >
        <TiContacts size={18} style={{ color: '#f68a20', flexShrink: 0 }} />
        <span>{props.t("My Contacts")}</span>
      </Link>

      <Link 
        to="/my-tickets" 
        style={{
          display: 'flex',
          alignItems: 'center',
          gap: '12px',
          padding: '10px 16px',
          color: '#e2e8f0',
          textDecoration: 'none',
          fontSize: '13px',
          transition: 'all 0.2s ease'
        }}
        onMouseEnter={(e) => {
          e.currentTarget.style.backgroundColor = '#334155';
          e.currentTarget.style.color = '#f68a20';
        }}
        onMouseLeave={(e) => {
          e.currentTarget.style.backgroundColor = 'transparent';
          e.currentTarget.style.color = '#e2e8f0';
        }}
        onClick={() => setMenu(false)}
      >
        <IoTicketOutline size={16} style={{ color: '#f68a20', flexShrink: 0 }} />
        <span>{props.t("My Tickets")}</span>
      </Link>

      <div style={{ borderTop: '1px solid #334155', margin: '8px 0' }}></div>

      <Link 
        to="/logout" 
        style={{
          display: 'flex',
          alignItems: 'center',
          gap: '12px',
          padding: '10px 16px',
          color: '#ef4444',
          textDecoration: 'none',
          fontSize: '13px',
          transition: 'all 0.2s ease'
        }}
        onMouseEnter={(e) => {
          e.currentTarget.style.backgroundColor = '#334155';
        }}
        onMouseLeave={(e) => {
          e.currentTarget.style.backgroundColor = 'transparent';
        }}
        onClick={() => setMenu(false)}
      >
        <i className="ri-shut-down-line" style={{ fontSize: '16px', flexShrink: 0 }} />
        <span>{props.t("Logout")}</span>
      </Link>
    </div>
  );

  return (
    <React.Fragment>
      {/* Profile Button */}
      <button
        ref={buttonRef}
        onClick={toggle}
        className="btn header-item"
        id="page-header-user-dropdown"
        style={{
          background: 'transparent',
          border: 'none',
          cursor: 'pointer',
          padding: '6px',
          display: 'flex',
          alignItems: 'center',
          gap: '8px',
          zIndex: 10000000,
          position: 'relative'
        }}
        aria-expanded={menu}
        aria-label="User menu"
      >
        <img
          className="rounded-circle header-profile-user"
          src={userImage ? userImage : userImg}
          alt="Header Avatar"
          style={{ 
            width: '32px', 
            height: '32px', 
            objectFit: 'cover',
            border: '2px solid #f68a20'
          }}
        />
        <span 
          className="d-none d-xl-inline-block"
          style={{ color: '#1a1d21', fontSize: '14px', fontWeight: '500' }}
        >
          {capitalizedFirstName}
        </span>
        <i 
          className="mdi mdi-chevron-down d-none d-xl-inline-block"
          style={{ 
            color: '#1a1d21',
            transition: 'transform 0.2s ease',
            transform: menu ? 'rotate(180deg)' : 'rotate(0)'
          }} 
        />
      </button>

      {/* Render dropdown using portal for mobile visibility */}
      {menu && ReactDOM.createPortal(dropdownContent, document.body)}
    </React.Fragment>
  );
};

ProfileMenu.propTypes = {
  success: PropTypes.any,
  t: PropTypes.any,
};

const mapStatetoProps = (state) => {
  const { error, success } = state.profile;
  return { error, success };
};

export default withRouter(
  connect(mapStatetoProps, {})(withTranslation()(ProfileMenu))
);